// IDs seeded by server/sql/002_periferice.sql (mirror of server peripheral.constants.ts)
export const PERIPHERAL_EQUIPMENT_TYPE_ID = 8;
export const PERIPHERAL_EQUIPMENT_TYPE = "Periferice";

// Chain of Periferice requests filed before 005: User(18) -> Șef departament(19) -> Rector(20) -> inginer-pc.
// Since 005 new ones go through Contabilitate like everything else (standard chain).
export const PERIPHERAL_STAGES = {
  USER_CREATED: 18,
  SUPERVISOR_APPROVED: 19,
  RECTOR_APPROVED: 20,
};

// Steps added by server/sql/005_configurare.sql (response_types)
export const STAGES_005 = {
  CORRECTED: 21, // the author's one correction after Contabilitate rejected: back to the Șef
  CANCELLED: 22, // cancelled by an admin (requests are never deleted)
  DATA_CHANGED: 23, // a logged edit of the item; the request does not move
};

// Added by server/sql/008_echipamente_qr.sql
export const STAGES_008 = {
  COMMENT: 24, // a comment (with photos) at any time; the request does not move
};

// Timeline entries: never the stage a request is at (server TIMELINE_STAGES)
export const TIMELINE_STAGES = [STAGES_005.DATA_CHANGED, STAGES_008.COMMENT];

export const PERIPHERAL_REQUEST_TYPES = {
  NEW_ITEM: [26, 27], // Procurare, Eliberare de la depozit of a new item
  EXISTING_ITEM: [28, 29], // Reparare, Înlocuire (defect): pick a peripheral the user already has
};
export const ALL_PERIPHERAL_REQUEST_TYPES = [
  ...PERIPHERAL_REQUEST_TYPES.NEW_ITEM,
  ...PERIPHERAL_REQUEST_TYPES.EXISTING_ITEM,
];

// "Căști defect" / "Boxe defecte" now go through Periferice
export const PC_REQUEST_TYPES_MOVED_TO_PERIPHERALS = [14, 15];

// Equipment types handled by inginer-pc before Configurare (fallback for rows without engineerRole)
export const PC_ENGINEER_EQUIPMENT = ["Calculatoare", PERIPHERAL_EQUIPMENT_TYPE];

// Roles that can be a type's engineer (server ENGINEER_ROLES). "admin" only for the types Configurare gives the
// admins: they do that work and stay admins everywhere else
export const ENGINEER_ROLES = ["inginer", "inginer-pc", "admin"];

/**
 * Rows an engineer works on. Requests carry the engineer they were filed for and equipment rows the one
 * their type has today (`engineerRole`, set in Configurare).
 */
export function engineerRowsFor(role, rows) {
  return (rows || []).filter((row) => {
    if (row.engineerRole) return row.engineerRole === role;
    // rows from before Configurare: printers for inginer, PCs and peripherals for inginer-pc, none for the admins
    if (role !== "inginer" && role !== "inginer-pc") return false;
    const pc = PC_ENGINEER_EQUIPMENT.includes(row.equipment || row.equipmentType);
    return role === "inginer-pc" ? pc : !pc;
  });
}

// Configurare (types, causes, circuits, catalog, departments, rooms): admin, Șef DTI, inginer; inginer-pc left out
// for now (2026-10-01; server CONFIG_EDITORS)
export const CONFIG_ROLES = ["admin", "dtisef", "inginer"];
export const CATALOG_MANAGER_ROLES = CONFIG_ROLES;
// Who fixes the item of a new-item request (server EQUIPMENT_MANAGERS / ITEM_EDITORS)
export const ITEM_EDITOR_ROLES = ["admin", "dtisef", "inginer", "inginer-pc"];
